// extracted by mini-css-extract-plugin
module.exports = {"fileInput":"file-input-a33"};